import { children, elements, html, ref, slotted, when } from "@microsoft/fast-element";
import { telemetry } from "../utilities/telemetry";
import { ContentCardLayout } from "./content-card";
const footer = html `
    <div
        class="footer ${x => (x.hasAbstract ? "has-abstract-footer" : "")} ${x => x.hasFooter ? "" : "footer__hidden"}"
        part="footer"
    >
        <span part="start-actions" ${ref("startActionsContainer")}>
            <slot
                name="start-actions"
                ${ref("startActions")}
                @slotchange=${x => x.handleStartActionsContentChange()}
            ></slot>
        </span>
        <span part="end-actions" ${ref("endActionsContainer")}>
            <slot
                name="end-actions"
                ${ref("endActions")}
                @slotchange=${x => x.handleEndActionsContentChange()}
            ></slot>
        </span>
    </div>
`;
export const ContentCardTemplate = html `
    <template
        ${children({
    property: "mediaNodes",
    filter: elements("[slot='media'], [slot='icon']"),
})}
    >
        <span part="background-image" ${ref("backgroundImageContainer")}>
            <slot
                name="background-image"
                ${ref("backgroundImage")}
                @slotchange=${x => x.handleBackgroundImageContentChange()}
            ></slot>
        </span>
        <div class="mask" part="mask"></div>
        <div class="body ${x => (x.hasAbstract ? "has-abstract" : "")}" part="body">
            ${when(x => { var _a; return ((_a = x.mediaNodes) === null || _a === void 0 ? void 0 : _a.length) > 0; }, html ` <div class="media-wrapper" part="media-wrapper">
                    <div part="media" ${ref("mediaContainer")}>
                        <slot
                            name="media"
                            ${ref("media")}
                            @slotchange=${x => x.handleMediaContentChange()}
                        ></slot>
                        <slot
                            name="content-indicator"
                            ${slotted("contentIndicatorNodes")}
                        ></slot>
                        <span
                            part="icon"
                            ${ref("iconContainer")}
                            class="${x => x.iconSlottedNodes && x.iconSlottedNodes.length
    ? "icon"
    : "icon__hidden"}"
                        >
                            <slot
                                name="icon"
                                ${ref("icon")}
                                ${slotted("iconSlottedNodes")}
                            ></slot>
                        </span>
                    </div>
                </div>`)}
            <div class="heading-container" part="heading-container">
                ${when(x => { var _a; return ((_a = x.mediaNodes) === null || _a === void 0 ? void 0 : _a.length) === 0; }, html `
                        <slot
                            name="content-indicator"
                            ${slotted("contentIndicatorNodes")}
                        ></slot>
                    `)}
                <slot name="attribution"></slot>
                <span
                    class="heading-wrapper"
                    part="heading-wrapper"
                    role="heading"
                    aria-level=${x => x.headinglevel}
                >
                    <a
                        class="heading"
                        part="heading"
                        href=${x => (x.href ? x.href : void 0)}
                        target=${x => (x.target ? x.target : void 0)}
                        @click=${(x, c) => x.handleContentCardLinkClick(c.event)}
                        ${telemetry(x => x.anchorTelemetryTag)}
                        ><slot></slot
                    ></a>
                </span>
            </div>
            <div class="abstract">
                <slot name="abstract" ${slotted("abstract")}></slot>
            </div>
            <slot name="call-to-action"></slot>
            ${when(x => x.layout !== ContentCardLayout.default, footer)}
        </div>
        ${when(x => x.layout === ContentCardLayout.default, footer)}
        <span
            part="hover-actions"
            class="${x => x.hoverActionsSlottedNodes && x.hoverActionsSlottedNodes.length
    ? "hover-actions"
    : "hover-actions__hidden"}"
        >
            <slot name="hover-actions" ${slotted("hoverActionsSlottedNodes")}></slot>
        </span>
    </template>
`;
